import React, { useState } from 'react'
import './TicTacToe.css'

const TicTacToe = () => {
  const [winner, setWinner] = useState('');
  const [state, setState] = useState(Array(9).fill(''));
  const [isX, setIsX] = useState(true);

  const handleClick = (i) =>{
    if(winner != ''){
      setMessage(winner + " already won the game.");
    }else if(state[i] == ''){
      state[i] = isX ? 'X' : 'O';
      setState(state);
      setIsX(!isX);
      switchTurn(i);      
    }else{
      setMessage("This box is already used.");
    }
    
  }

  const checkWinner = (i) => {
    if(stratightLine(0,1,2,i) || stratightLine(3,4,5,i) || stratightLine(6,7,8,i) || stratightLine(0,3,6,i) || stratightLine(1,4,7,i) || stratightLine(2,5,8,i) || stratightLine(0,4,8,i) || stratightLine(2,4,6,i)){
      return true;
    }
  }

  const stratightLine = (a,b,c,i) => {
    if(state[a] == state[i] && state[b] == state[i] && state[c] == state[i]){
      return true;
    }else{
      return false;
    }
  }

  const switchTurn = (i) => {
    if(checkWinner(i)){
        setMessage("Congratulations "+ state[i] + "! You Won.");
       setWinner(state[i]);
    }else if(checkTie(i)){
      setMessage("It's a TIE..!! Play again..!!!")
    }else if(state[i] == 'X'){
      setMessage("It's O's turn!");
    }else{
      setMessage("It's X's turn!");
    }
  }

  const setMessage = (item) => {
    document.getElementById('message').textContent = item;
  }

  const checkTie = (i) => {
    for(let i=0;i<9;i++){
      if(state[i]==''){
        return false;
      }
    }
    return true;
  }

  const startGame = () => {
    setState(Array(9).fill(''));    
    setIsX(true);
    setWinner('');
    setMessage("X Gets to start...")
  }

  return (
    <div>
      <div className='container'>
          <h1 className='text'>Tic-Tac-Toe!</h1>
          <div id='message' className='text1'>X Gets to start...</div>
          <table className='table-container'>
            <tr>
              <td id='s1' className='square' onClick={()=>handleClick(0)}>{state[0]}</td>
              <td id='s2' className='square' onClick={()=>handleClick(1)}>{state[1]}</td>
              <td id='s3' className='square' onClick={()=>handleClick(2)}>{state[2]}</td>
            </tr>
            <tr>
              <td id='s4' className='square' onClick={()=>handleClick(3)}>{state[3]}</td>
              <td id='s5' className='square' onClick={()=>handleClick(4)}>{state[4]}</td>
              <td id='s6' className='square' onClick={()=>handleClick(5)}>{state[5]}</td>
            </tr>
            <tr>
              <td id='s8' className='square' onClick={()=>handleClick(6)}>{state[6]}</td>
              <td id='s9' className='square' onClick={()=>handleClick(7)}>{state[7]}</td>
              <td id='s7' className='square' onClick={()=>handleClick(8)}>{state[8]}</td>
            </tr>
          </table>
          <button type='button'  className='but' onClick={()=>startGame()}>Start New Game</button>
      </div>
    </div>
  )
}

export default TicTacToe